import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { HiPlusCircle } from 'react-icons/hi';
import { IoIosArrowBack } from 'react-icons/io';
import MarqueNotice from './SpaceRequirement/MarqueNotice';

type IProps = {
  createBtnText?: string;
  addHeadingTitle?: string;
  listHeadingTitle?: string;
  setToggle?: React.Dispatch<React.SetStateAction<boolean>>;
  toggle?: boolean;
  isMarque?: boolean;
  notShowingRightSide?: boolean;
};
const CommProfileHeader = ({
  createBtnText,
  addHeadingTitle,
  listHeadingTitle,
  setToggle,
  toggle,
  isMarque,
  notShowingRightSide,
}: IProps) => {
  return (
    <div className='profile-right-side px-3 py-3 mb-2'>
      <Row className='gy-3 gx-4 align-items-center justify-content-between'>
        <Col
          xs={6}
          sm={6}
          md={6}
          lg={6}
          xl={6}
          xxl={isMarque ? 3 : 4}
          className='order-1 order-lg-1'
        >
          <h5>{toggle ? addHeadingTitle : listHeadingTitle}</h5>
        </Col>

        {/* Marquee Section */}
        {isMarque && (
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            xxl={7}
            className='order-3 order-xl-3'
          >
            <MarqueNotice />
          </Col>
        )}

        {/* Toggle Button Section */}

        {!notShowingRightSide && (
          <Col
            xs={6}
            sm={6}
            md={6}
            lg={isMarque ? 3 : 4}
            xl={6}
            xxl={isMarque ? 2 : 3}
            className='order-2 order-xl-2 order-xxl-3 d-flex justify-content-end'
          >
            <div
              onClick={() => setToggle?.(!toggle)}
              className='d-flex align-items-center gap-1 pointer'
              style={{
                backgroundColor: '#1a7f37',
                color: 'white',
                padding: '5px 7px',
                borderRadius: '5px',
              }}
            >
              {toggle ? (
                <>
                  <IoIosArrowBack />
                  <p>Back</p>
                </>
              ) : (
                <>
                  <HiPlusCircle />
                  <p>{createBtnText}</p>
                </>
              )}
            </div>
          </Col>
        )}
      </Row>

      {/* <div className='d-flex align-items-center justify-content-between'>
        <h5>{toggle ? addHeadingTitle : listHeadingTitle} </h5>

        <div
        // fluid
        // className='d-flex justify-content-center bg-light py-3'
        >
          <div className='marquee-container'>
            <div className='marquee'>
              <span>
                তিন দিনের মধ্যে স্টলের পেমেন্ট সম্পন্ন না করলে বুকিং বাতিল করে
                দেওয়া হবে।
              </span>
            </div>
          </div>
        </div>

        <div
          onClick={() => setToggle?.(!toggle)}
          className='d-flex  align-items-center gap-1 pointer'
          style={{
            backgroundColor: '#1982c3',
            color: 'white',
            padding: '5px 7px',
            borderRadius: '5px',
          }}
        >
          {toggle ? (
            <>
              <IoIosArrowBack />
              <p>Back</p>
            </>
          ) : (
            <>
              <HiPlusCircle />
              <p>{createBtnText}</p>
            </>
          )}
        </div>
      </div> */}
    </div>
  );
};

export default CommProfileHeader;
